const state = {
  userInfo: {}, // 用户信息 

  userInfo2: {}, // 用户信息 

  batchIndex: undefined, // 批次索引 
  batchList: [], // 批次数据 
  batchData: {}, // 批次详情数据 

  loginState: false, 
};

const mutations = { 
  SET_USER_INFO: (state, data) => { 
    state.userInfo = data || {}; 
  }, 
  SET_USER_INFO_NAME: (state, data) => { 
    state.userInfo.employeeName = data; 
  }, 
  SET_USER_INFO_IMG: (state, data) => { 
    state.userInfo.studentImage = data; 
  }, 

  SET_USER_INFO2: (state, data) => { 
    state.userInfo2 = data || {}; 
  }, 
  SET_USER_INFO_NAME2: (state, data) => { 
    state.userInfo2.employeeName = data; 
  }, 
  SET_USER_INFO_IMG2: (state, data) => { 
    state.userInfo2.studentImage = data; 
  }, 

  SET_BATCH_INDEX: (state, data) => { 
    state.batchIndex = data; 
  }, 
  SET_BATCH_LIST: (state, data) => { 
    state.batchList = data; 
  }, 
  SET_BATCH_DATA: (state, data) => { 
    state.batchData = data; 
  }, 

  SET_LOGIN_STATE: (state, data) => { 
    state.loginState = data; 
  }, 
};

const getters = {
  getUserInfo(state) {
    return state.userInfo;
  },

  getUserInfo2(state) {
    if (!state.userInfo2?.employeeName) {
      let data = JSON.parse(localStorage.getItem("userInfo2"));
      mutations.SET_USER_INFO2(state, data)
    }
    return state.userInfo2;
  },
  getBatchIndex(state) {
    return state.batchIndex;
  },
  getBatchList(state) { 
    return state.batchList;
  },
  getBatchData(state) {
    return state.batchData;
  },
  getLoginState(state) {
    return state.loginState;
  },
}; 

export default {
  namespaced: true,
  state,
  mutations,
  getters, 
};
